import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    O_AUTH_TOKEN_KEY,
    OAuthTokenState,
    selectAllOAuthToken,
    selectOAuthTokenEntities,
    selectOAuthTokenFetched,
} from '../reducers/o-auth-token.reducer';



const selectState = createFeatureSelector<OAuthTokenState>(O_AUTH_TOKEN_KEY);
const getDictionary = createSelector(selectState, selectOAuthTokenEntities);

export const getOAuthTokenDictionary = getDictionary;
export const getOAuthToken = createSelector(selectState, selectAllOAuthToken);
export const getOAuthTokenFetched = createSelector(selectState, selectOAuthTokenFetched);
export const getOAuthTokenById = (props: { id: number }) => createSelector(getDictionary, (dictionary) => props?.id && dictionary[props.id]);
